/*
 * Copyright (c) Arbeidskracht Groep B.V. - all rights reserved
 */

import {createAction} from 'typesafe-actions';
import {
	AccountEmailChangeStateDTO,
	AccountRecoveryStateDTO,
	ConstraintViolationDTO,
	EmployeeRegistrationStateDTO,
	FlexServiceWorkerRegistrationStateDTO,
	PasswordStrengthDTO,
	PhoneNumberLookupResultDTO,
	RememberMeAuthenticationResultDTO
} from '../../generated/iam-client';

export const iamApiAccountEmailChangeStateRetrieved =
	createAction('IAM_API_ACCOUNT_EMAIL_CHANGE_STATE_RETRIEVED')<{ state: AccountEmailChangeStateDTO }>();

export const iamApiRetrieveAccountEmailChangeStateNotFound =
	createAction('IAM_API_RETRIEVE_ACCOUNT_EMAIL_CHANGE_STATE_NOT_FOUND')();

export const iamApiRetrieveAccountEmailChangeStateUnexpectedError =
	createAction('IAM_API_RETRIEVE_ACCOUNT_EMAIL_CHANGE_STATE_UNEXPECTED_ERROR')();

export const iamApiAccountRecoveryStarted =
	createAction('IAM_API_ACCOUNT_RECOVERY_STARTED')();

export const iamApiStartAccountRecoveryValidationException =
	createAction('IAM_API_START_ACCOUNT_RECOVERY_VALIDATION_EXCEPTION')<{ violations: ConstraintViolationDTO[] }>();

export const iamApiStartAccountRecoveryUnexpectedError =
	createAction('IAM_API_START_ACCOUNT_RECOVERY_UNEXPECTED_ERROR')();

export const iamApiAccountRecoveryStateRetrieved =
	createAction('IAM_API_ACCOUNT_RECOVERY_STATE_RETRIEVED')<{ state: AccountRecoveryStateDTO }>();

export const iamApiRetrieveAccountRecoveryStateNotFound =
	createAction('IAM_API_RETRIEVE_ACCOUNT_RECOVERY_STATE_NOT_FOUND')();

export const iamApiRetrieveAccountRecoveryStateUnexpectedError =
	createAction('IAM_API_RETRIEVE_ACCOUNT_RECOVERY_STATE_UNEXPECTED_ERROR')();

export const iamApiAccountRecoveryRetryPhoneVerificationRequested =
	createAction('IAM_API_ACCOUNT_RECOVERY_RETRY_PHONE_VERIFICATION_REQUESTED')();

export const iamApiAccountRecoveryRetryPhoneVerificationNotFound =
	createAction('IAM_API_ACCOUNT_RECOVERY_RETRY_PHONE_VERIFICATION_NOT_FOUND')();

export const iamApiAccountRecoveryRetryPhoneVerificationUnexpectedError =
	createAction('IAM_API_ACCOUNT_RECOVERY_RETRY_PHONE_VERIFICATION_UNEXPECTED_ERROR')();

export const iamApiAccountRecoveryRestartPhoneVerificationRequested =
	createAction('IAM_API_ACCOUNT_RECOVERY_RESTART_PHONE_VERIFICATION_REQUESTED')();

export const iamApiAccountRecoveryRestartPhoneVerificationNotFound =
	createAction('IAM_API_ACCOUNT_RECOVERY_RESTART_PHONE_VERIFICATION_NOT_FOUND')();

export const iamApiAccountRecoveryRestartPhoneVerificationUnexpectedError =
	createAction('IAM_API_ACCOUNT_RECOVERY_RESTART_PHONE_VERIFICATION_UNEXPECTED_ERROR')();

export const iamApiAccountRecoveryPhoneVerificationCodeEntered =
	createAction('IAM_API_ACCOUNT_RECOVERY_PHONE_VERIFICATION_CODE_ENTERED')();

export const iamApiAccountRecoveryEnterPhoneVerificationCodeNotFound =
	createAction('IAM_API_ACCOUNT_RECOVERY_ENTER_PHONE_VERIFICATION_CODE_NOT_FOUND')();

export const iamApiAccountRecoveryEnterPhoneVerificationCodeValidationException =
	createAction('IAM_API_ACCOUNT_RECOVERY_ENTER_PHONE_VERIFICATION_CODE_VALIDATION_EXCEPTION')<{ violations: ConstraintViolationDTO[] }>();

export const iamApiAccountRecoveryEnterPhoneVerificationCodeUnexpectedError =
	createAction('IAM_API_ACCOUNT_RECOVERY_ENTER_PHONE_VERIFICATION_CODE_UNEXPECTED_ERROR')();

export const iamApiAccountRecoveryPasswordStrengthEvaluated =
	createAction('IAM_API_ACCOUNT_RECOVERY_PASSWORD_STRENGTH_EVALUATED')<{ passwordStrength: PasswordStrengthDTO }>();

export const iamApiAccountRecoveryEvaluatePasswordStrengthNotFound =
	createAction('IAM_API_ACCOUNT_RECOVERY_EVALUATE_PASSWORD_STRENGTH_NOT_FOUND')();

export const iamApiAccountRecoveryEvaluatePasswordStrengthUnexpectedError =
	createAction('IAM_API_ACCOUNT_RECOVERY_EVALUATE_PASSWORD_STRENGTH_UNEXPECTED_ERROR')();

export const iamApiAccountRecoveryPasswordEntered =
	createAction('IAM_API_ACCOUNT_RECOVERY_PASSWORD_ENTERED')();

export const iamApiAccountRecoveryEnterPasswordNotFound =
	createAction('IAM_API_ACCOUNT_RECOVERY_ENTER_PASSWORD_NOT_FOUND')();

export const iamApiAccountRecoveryEnterPasswordValidationException =
	createAction('IAM_API_ACCOUNT_RECOVERY_ENTER_PASSWORD_VALIDATION_EXCEPTION')<{ violations: ConstraintViolationDTO[] }>();

export const iamApiAccountRecoveryEnterPasswordUnexpectedError =
	createAction('IAM_API_ACCOUNT_RECOVERY_ENTER_PASSWORD_UNEXPECTED_ERROR')();

export const iamApiEmployeeRegistrationStateRetrieved =
	createAction('IAM_API_EMPLOYEE_REGISTRATION_STATE_RETRIEVED')<{ state: EmployeeRegistrationStateDTO }>();

export const iamApiRetrieveEmployeeRegistrationStateNotFound =
	createAction('IAM_API_RETRIEVE_EMPLOYEE_REGISTRATION_STATE_NOT_FOUND')();

export const iamApiRetrieveEmployeeRegistrationStateUnexpectedError =
	createAction('IAM_API_RETRIEVE_EMPLOYEE_REGISTRATION_STATE_UNEXPECTED_ERROR')();

export const iamApiEmployeeRegistrationRetryPhoneVerificationRequested =
	createAction('IAM_API_EMPLOYEE_REGISTRATION_RETRY_PHONE_VERIFICATION_REQUESTED')();

export const iamApiEmployeeRegistrationRetryPhoneVerificationNotFound =
	createAction('IAM_API_EMPLOYEE_REGISTRATION_RETRY_PHONE_VERIFICATION_NOT_FOUND')();

export const iamApiEmployeeRegistrationRetryPhoneVerificationUnexpectedError =
	createAction('IAM_API_EMPLOYEE_REGISTRATION_RETRY_PHONE_VERIFICATION_UNEXPECTED_ERROR')();

export const iamApiEmployeeRegistrationRestartPhoneVerificationRequested =
	createAction('IAM_API_EMPLOYEE_REGISTRATION_RESTART_PHONE_VERIFICATION_REQUESTED')();

export const iamApiEmployeeRegistrationRestartPhoneVerificationNotFound =
	createAction('IAM_API_EMPLOYEE_REGISTRATION_RESTART_PHONE_VERIFICATION_NOT_FOUND')();

export const iamApiEmployeeRegistrationRestartPhoneVerificationUnexpectedError =
	createAction('IAM_API_EMPLOYEE_REGISTRATION_RESTART_PHONE_VERIFICATION_UNEXPECTED_ERROR')();

export const iamApiEmployeeRegistrationPhoneVerificationCodeEntered =
	createAction('IAM_API_EMPLOYEE_REGISTRATION_PHONE_VERIFICATION_CODE_ENTERED')();

export const iamApiEmployeeRegistrationEnterPhoneVerificationCodeNotFound =
	createAction('IAM_API_EMPLOYEE_REGISTRATION_ENTER_PHONE_VERIFICATION_CODE_NOT_FOUND')();

export const iamApiEmployeeRegistrationEnterPhoneVerificationCodeValidationException =
	createAction('IAM_API_EMPLOYEE_REGISTRATION_ENTER_PHONE_VERIFICATION_CODE_VALIDATION_EXCEPTION')<{
		violations: ConstraintViolationDTO[]
	}>();

export const iamApiEmployeeRegistrationEnterPhoneVerificationCodeUnexpectedError =
	createAction('IAM_API_EMPLOYEE_REGISTRATION_ENTER_PHONE_VERIFICATION_CODE_UNEXPECTED_ERROR')();

export const iamApiEmployeeRegistrationPasswordStrengthEvaluated =
	createAction('IAM_API_EMPLOYEE_REGISTRATION_PASSWORD_STRENGTH_EVALUATED')<{ passwordStrength: PasswordStrengthDTO }>();

export const iamApiEmployeeRegistrationEvaluatePasswordStrengthNotFound =
	createAction('IAM_API_EMPLOYEE_REGISTRATION_EVALUATE_PASSWORD_STRENGTH_NOT_FOUND')();

export const iamApiEmployeeRegistrationEvaluatePasswordStrengthUnexpectedError =
	createAction('IAM_API_EMPLOYEE_REGISTRATION_EVALUATE_PASSWORD_STRENGTH_UNEXPECTED_ERROR')();

export const iamApiEmployeeRegistrationPasswordEntered =
	createAction('IAM_API_EMPLOYEE_REGISTRATION_PASSWORD_ENTERED')();

export const iamApiEmployeeRegistrationEnterPasswordNotFound =
	createAction('IAM_API_EMPLOYEE_REGISTRATION_ENTER_PASSWORD_NOT_FOUND')();

export const iamApiEmployeeRegistrationEnterPasswordValidationException =
	createAction('IAM_API_EMPLOYEE_REGISTRATION_ENTER_PASSWORD_VALIDATION_EXCEPTION')<{ violations: ConstraintViolationDTO[] }>();

export const iamApiEmployeeRegistrationEnterPasswordUnexpectedError =
	createAction('IAM_API_EMPLOYEE_REGISTRATION_ENTER_PASSWORD_UNEXPECTED_ERROR')();

export const iamApiFlexServiceWorkerRegistrationStateRetrieved =
	createAction('IAM_API_FLEX_SERVICE_WORKER_REGISTRATION_STATE_RETRIEVED')<{ state: FlexServiceWorkerRegistrationStateDTO }>();

export const iamApiRetrieveFlexServiceWorkerRegistrationStateNotFound =
	createAction('IAM_API_RETRIEVE_FLEX_SERVICE_WORKER_REGISTRATION_STATE_NOT_FOUND')();

export const iamApiRetrieveFlexServiceWorkerRegistrationStateUnexpectedError =
	createAction('IAM_API_RETRIEVE_FLEX_SERVICE_WORKER_REGISTRATION_STATE_UNEXPECTED_ERROR')();

export const iamApiFlexServiceWorkerRegistrationPhoneNumberEntered =
	createAction('IAM_API_FLEX_SERVICE_WORKER_REGISTRATION_PHONE_NUMBER_ENTERED')();

export const iamApiFlexServiceWorkerRegistrationEnterPhoneNumberNotFound =
	createAction('IAM_API_FLEX_SERVICE_WORKER_REGISTRATION_ENTER_PHONE_NUMBER_NOT_FOUND')();

export const iamApiFlexServiceWorkerRegistrationEnterPhoneNumberValidationException =
	createAction('IAM_API_FLEX_SERVICE_WORKER_REGISTRATION_ENTER_PHONE_NUMBER_VALIDATION_EXCEPTION')<{
		violations: ConstraintViolationDTO[]
	}>();

export const iamApiFlexServiceWorkerRegistrationEnterPhoneNumberUnexpectedError =
	createAction('IAM_API_FLEX_SERVICE_WORKER_REGISTRATION_ENTER_PHONE_NUMBER_UNEXPECTED_ERROR')();

export const iamApiFlexServiceWorkerRegistrationStopPhoneVerificationRequested =
	createAction('IAM_API_FLEX_SERVICE_WORKER_REGISTRATION_STOP_PHONE_VERIFICATION_REQUESTED')();

export const iamApiFlexServiceWorkerRegistrationStopPhoneVerificationNotFound =
	createAction('IAM_API_FLEX_SERVICE_WORKER_REGISTRATION_STOP_PHONE_VERIFICATION_NOT_FOUND')();

export const iamApiFlexServiceWorkerRegistrationStopPhoneVerificationUnexpectedError =
	createAction('IAM_API_FLEX_SERVICE_WORKER_REGISTRATION_STOP_PHONE_VERIFICATION_UNEXPECTED_ERROR')();

export const iamApiFlexServiceWorkerRegistrationPhoneVerificationCodeEntered =
	createAction('IAM_API_FLEX_SERVICE_WORKER_REGISTRATION_PHONE_VERIFICATION_CODE_ENTERED')();

export const iamApiFlexServiceWorkerRegistrationEnterPhoneVerificationCodeNotFound =
	createAction('IAM_API_FLEX_SERVICE_WORKER_REGISTRATION_ENTER_PHONE_VERIFICATION_CODE_NOT_FOUND')();

export const iamApiFlexServiceWorkerRegistrationEnterPhoneVerificationCodeValidationException =
	createAction('IAM_API_FLEX_SERVICE_WORKER_REGISTRATION_ENTER_PHONE_VERIFICATION_CODE_VALIDATION_EXCEPTION')<{
		violations: ConstraintViolationDTO[]
	}>();

export const iamApiFlexServiceWorkerRegistrationEnterPhoneVerificationCodeUnexpectedError =
	createAction('IAM_API_FLEX_SERVICE_WORKER_REGISTRATION_ENTER_PHONE_VERIFICATION_CODE_UNEXPECTED_ERROR')();

export const iamApiFlexServiceWorkerRegistrationResolvePersonalNameRequested =
	createAction('IAM_API_FLEX_SERVICE_WORKER_REGISTRATION_RESOLVE_PERSONAL_NAME_REQUESTED')();

export const iamApiFlexServiceWorkerRegistrationResolvePersonalNameNotFound =
	createAction('IAM_API_FLEX_SERVICE_WORKER_REGISTRATION_RESOLVE_PERSONAL_NAME_NOT_FOUND')();

export const iamApiFlexServiceWorkerRegistrationResolvePersonalNameUnexpectedError =
	createAction('IAM_API_FLEX_SERVICE_WORKER_REGISTRATION_RESOLVE_PERSONAL_NAME_UNEXPECTED_ERROR')();

export const iamApiFlexServiceWorkerRegistrationPasswordStrengthEvaluated =
	createAction('IAM_API_FLEX_SERVICE_WORKER_REGISTRATION_PASSWORD_STRENGTH_EVALUATED')<{ passwordStrength: PasswordStrengthDTO }>();

export const iamApiFlexServiceWorkerRegistrationEvaluatePasswordStrengthNotFound =
	createAction('IAM_API_FLEX_SERVICE_WORKER_REGISTRATION_EVALUATE_PASSWORD_STRENGTH_NOT_FOUND')();

export const iamApiFlexServiceWorkerRegistrationEvaluatePasswordStrengthUnexpectedError =
	createAction('IAM_API_FLEX_SERVICE_WORKER_REGISTRATION_EVALUATE_PASSWORD_STRENGTH_UNEXPECTED_ERROR')();

export const iamApiFlexServiceWorkerRegistrationPasswordEntered =
	createAction('IAM_API_FLEX_SERVICE_WORKER_REGISTRATION_PASSWORD_ENTERED')();

export const iamApiFlexServiceWorkerRegistrationEnterPasswordNotFound =
	createAction('IAM_API_FLEX_SERVICE_WORKER_REGISTRATION_ENTER_PASSWORD_NOT_FOUND')();

export const iamApiFlexServiceWorkerRegistrationEnterPasswordValidationException =
	createAction('IAM_API_FLEX_SERVICE_WORKER_REGISTRATION_ENTER_PASSWORD_VALIDATION_EXCEPTION')<{
		violations: ConstraintViolationDTO[]
	}>();

export const iamApiFlexServiceWorkerRegistrationEnterPasswordUnexpectedError =
	createAction('IAM_API_FLEX_SERVICE_WORKER_REGISTRATION_ENTER_PASSWORD_UNEXPECTED_ERROR')();

export const iamApiPasswordStrengthEvaluated =
	createAction('IAM_API_PASSWORD_STRENGTH_EVALUATED')<{ passwordStrength: PasswordStrengthDTO }>();

export const iamApiEvaluatePasswordStrengthUnexpectedError =
	createAction('IAM_API_EVALUATE_PASSWORD_STRENGTH_UNEXPECTED_ERROR')();

export const iamApiPhoneNumberLookupPerformed =
	createAction('IAM_API_PHONE_NUMBER_LOOKUP_PERFORMED')<{ result: PhoneNumberLookupResultDTO }>();

export const iamApiPerformPhoneNumberLookupUnexpectedError =
	createAction('IAM_API_PERFORM_PHONE_NUMBER_LOOKUP_UNEXPECTED_ERROR')();

export const iamApiRememberMeAuthenticationStarted =
	createAction('IAM_API_REMEMBER_ME_AUTHENTICATION_STARTED')<{ result: RememberMeAuthenticationResultDTO }>();

export const iamApiStartRememberMeAuthenticationValidationException =
	createAction('IAM_API_START_REMEMBER_ME_AUTHENTICATION_VALIDATION_EXCEPTION')<{ violations: ConstraintViolationDTO[] }>();

export const iamApiStartRememberMeAuthenticationUnexpectedError =
	createAction('IAM_API_START_REMEMBER_ME_AUTHENTICATION_UNEXPECTED_ERROR')();

export const iamApiAuthenticationStarted =
	createAction('IAM_API_AUTHENTICATION_STARTED')<{ twoFactorAuthenticationId: string }>();

export const iamApiStartAuthenticationValidationException =
	createAction('IAM_API_START_AUTHENTICATION_VALIDATION_EXCEPTION')<{ violations: ConstraintViolationDTO[] }>();

export const iamApiStartAuthenticationUnexpectedError =
	createAction('IAM_API_START_AUTHENTICATION_UNEXPECTED_ERROR')();

export const iamApiAuthenticationRetryPhoneVerificationRequested =
	createAction('IAM_API_AUTHENTICATION_RETRY_PHONE_VERIFICATION_REQUESTED')();

export const iamApiAuthenticationRetryPhoneVerificationNotFound =
	createAction('IAM_API_AUTHENTICATION_RETRY_PHONE_VERIFICATION_NOT_FOUND')();

export const iamApiAuthenticationRetryPhoneVerificationUnexpectedError =
	createAction('IAM_API_AUTHENTICATION_RETRY_PHONE_VERIFICATION_UNEXPECTED_ERROR')();

export const iamApiAuthenticationRestartPhoneVerificationRequested =
	createAction('IAM_API_AUTHENTICATION_RESTART_PHONE_VERIFICATION_REQUESTED')();

export const iamApiAuthenticationRestartPhoneVerificationNotFound =
	createAction('IAM_API_AUTHENTICATION_RESTART_PHONE_VERIFICATION_NOT_FOUND')();

export const iamApiAuthenticationRestartPhoneVerificationUnexpectedError =
	createAction('IAM_API_AUTHENTICATION_RESTART_PHONE_VERIFICATION_UNEXPECTED_ERROR')();

export const iamApiAuthenticationPhoneVerificationCodeEntered =
	createAction('IAM_API_AUTHENTICATION_PHONE_VERIFICATION_CODE_ENTERED')();

export const iamApiAuthenticationEnterPhoneVerificationCodeNotFound =
	createAction('IAM_API_AUTHENTICATION_ENTER_PHONE_VERIFICATION_CODE_NOT_FOUND')();

export const iamApiAuthenticationEnterPhoneVerificationCodeValidationException =
	createAction('IAM_API_AUTHENTICATION_ENTER_PHONE_VERIFICATION_CODE_VALIDATION_EXCEPTION')<{ violations: ConstraintViolationDTO[] }>();

export const iamApiAuthenticationEnterPhoneVerificationCodeUnexpectedError =
	createAction('IAM_API_AUTHENTICATION_ENTER_PHONE_VERIFICATION_CODE_UNEXPECTED_ERROR')();

export const iamApiAuthenticationPasswordChanged =
	createAction('IAM_API_AUTHENTICATION_PASSWORD_CHANGED')();

export const iamApiAuthenticationChangePasswordNotFound =
	createAction('IAM_API_AUTHENTICATION_CHANGE_PASSWORD_NOT_FOUND')();

export const iamApiAuthenticationChangePasswordValidationException =
	createAction('IAM_API_AUTHENTICATION_CHANGE_PASSWORD_VALIDATION_EXCEPTION')<{ violations: ConstraintViolationDTO[] }>();

export const iamApiAuthenticationChangePasswordUnexpectedError =
	createAction('IAM_API_AUTHENTICATION_CHANGE_PASSWORD_UNEXPECTED_ERROR')();
